module.exports = __webpack_public_path__ + "img/account-advisor-ico-01.3c41a2d9.svg";